async function hashBlob(blob: Blob): Promise<string> {
  const buffer = await blob.arrayBuffer()
  const hashBuffer = await crypto.subtle.digest('SHA-256', buffer)
  return Array.from(new Uint8Array(hashBuffer))
    .map(buffer => buffer.toString(16).padStart(2, '0'))
    .join('')
}

export async function isBlobDifferentFromFile(blob: Blob, file: File): Promise<boolean> {
  const [blobHash, fileHash] = await Promise.all([hashBlob(blob), hashBlob(file)])
  return blobHash !== fileHash
}
